import React from "react";
import { useLocation } from "react-router-dom";

const Success = () => {
  const location = useLocation();
  const { customerName } = location.state || {}; // <-- Get customerName from route state

  // ✅ Redirect guard: If no data, show a fallback UI
  if (!customerName) {
    return (
      <div className="form_wrapper">
        <div className="content">
          <div className="main_content">
            <p>Oops! No registration data found. Please start from the beginning.</p>
          </div>
        </div>
      </div>
    );
  }

  // ✅ Main success page content
  return (
    <div className="form_wrapper">
      <div className="content">
        <div className="left_content"></div>
        <div className="main_content">
          <div className="thank_you_container">
            <article className="thank_you_article">
              <img
                className="thank-you-icon"
                src="/img/Success_Icon_60x60.svg"
                alt="Success"
              />
              <h1 className="display-4"><b>Thank You!</b></h1>
            </article>
            <article className="thank_you_article_text">
              <h4><b>You have successfully created your Tiger Bridge subscription.</b></h4>
              <p>
                  To proceed to installation, please log in to your Tiger Technology Licensing Server account with 
                  your username and password and access the Downloads section in your Tiger Bridge order.  
              </p>
              <br />
              <p><a href="https://license.tiger-technology.com">Go to My Account</a></p>
              <p><b>Username:</b> {customerName}</p>
            </article>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
